//Toutes les actions possibles sur un module 🤖☂️
//Voir aussi 👉 : https://www.notion.so/Byte-mapping-2b8092aeace080e89fe2f70ed1748005?source=copy_link

export enum ModuleCommandEnum {
  PAUSE = "PAUSE",
  RESET = "RESET",
  FOLD = "FOLD",
  UNFOLD = "UNFOLD",
  GET_STATUS = "GET_STATUS",
  RESUME = "RESUME",
  CANCEL = "CANCEL",
  CLOSE = "CLOSE",
  OPEN = "OPEN",
  UP = "UP",
  DOWN = "DOWN",
}
